module.exports = __webpack_public_path__ + "img/69ne.04759d82.svg";